import React from 'react';
import { Box } from '@mui/material';
import pxToRem from 'assets/theme/function/px-to-rem';
import rgba from 'assets/theme/function/rgba';
import colors from 'assets/theme/base/colors';
import borders from 'assets/theme/base/borders';
import { API_ENDPOINT_URL } from 'constant';

interface Props {
    userId?: string;
}

const Image: React.FC<Props> = (props: Props) => {
    const { userId } = props;

    return (
        <>
            <Box
                flexBasis={'15%'}
                border={`1px solid ${rgba(colors.info.main, 0.5)}`}
                borderRadius={borders.borderRadius.md}
                p={pxToRem(8)}
                textAlign={'center'}
            >
                <Box
                    component="img"
                    src={`${API_ENDPOINT_URL}/avatar/file/${userId}`}
                    alt=""
                    sx={{
                        width: 150,
                        height: 120,
                        objectFit: 'contain',
                        objectPosition: 'top',
                        borderRadius: borders.borderRadius.md,
                        mr: pxToRem(8),
                    }}
                />
            </Box>
        </>
    );
};

export default Image;
